import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getOrCreateExamAttempt, listOpenExamSessionsForStudent } from '../services/exam2Api'
import { useResponsiveContext } from '../context/ResponsiveContext'

export default function ExamSessionLanding() {
  const navigate = useNavigate()
  const { sessionId } = useParams()
  const { isMobile } = useResponsiveContext()

  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [starting, setStarting] = useState(false)

  useEffect(() => {
    let cancelled = false
    async function run() {
      if (!sessionId) return
      setLoading(true)
      setErrorMsg('')
      try {
        const all = await listOpenExamSessionsForStudent()
        if (cancelled) return
        const s = (all || []).find(x => x.session_id === sessionId)
        if (!s) {
          setErrorMsg('لم يتم العثور على هذا الامتحان أو أنك غير مخول له.')
        }
        setSession(s || null)
      } catch (e) {
        if (!cancelled) {
          setErrorMsg(e?.message || 'فشل تحميل بيانات الامتحان')
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    run()
    return () => { cancelled = true }
  }, [sessionId])

  async function onStart() {
    if (!sessionId) return
    setStarting(true)
    setErrorMsg('')
    try {
      const attempt = await getOrCreateExamAttempt(sessionId)
      if (!attempt) throw new Error('فشل إنشاء أو استئناف المحاولة')
      navigate(`/exams/${sessionId}/attempt/${attempt.id}`)
    } catch (e) {
      const msg = e?.message || ''
      if (msg.includes('Session not currently open')) {
        setErrorMsg('لا يمكنك بدء هذا الامتحان الآن، الوقت المحدد له غير مفتوح حالياً.')
      } else {
        setErrorMsg(msg || 'فشل بدء/استئناف الامتحان')
      }
    } finally {
      setStarting(false)
    }
  }

  if (loading) {
    return (
      <div
        dir="rtl"
        style={{
          minHeight: '100vh',
          backgroundColor: '#f3f4f6',
          padding: isMobile ? '1rem' : '1.5rem',
        }}
      >
        <div style={{ maxWidth: 720, margin: '0 auto' }}>جاري التحميل...</div>
      </div>
    )
  }

  if (errorMsg && !session) {
    return (
      <div
        dir="rtl"
        style={{
          minHeight: '100vh',
          backgroundColor: '#f3f4f6',
          padding: '1.5rem',
        }}
      >
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ padding: 10, borderRadius: 10, border: '1px solid #fecaca', background: '#fff1f2', color: '#7f1d1d' }}>{errorMsg}</div>
        </div>
      </div>
    )
  }

  if (!session) return null

  const starts = session.starts_at ? new Date(session.starts_at).toLocaleString('ar-EG') : '—'
  const ends = session.ends_at ? new Date(session.ends_at).toLocaleString('ar-EG') : '—'

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: isMobile ? '1rem' : '1.5rem',
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 16,
            padding: 16,
            boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
            display: 'grid',
            gap: 12,
          }}
        >
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>{session.title || session.paper_title || 'امتحان أونلاين'}</h1>

          {errorMsg ? (
            <div style={{ padding: 10, borderRadius: 10, border: '1px solid #fecaca', background: '#fff1f2', color: '#7f1d1d' }}>{errorMsg}</div>
          ) : null}

          <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 12, background: '#ffffff', display: 'grid', gap: 6 }}>
            <div style={{ fontSize: 14, color: '#111827' }}>
              <strong>الفترة الزمنية:</strong>
              {' '}
              من {starts} إلى {ends}
            </div>
            {session.duration_minutes != null && (
              <div style={{ fontSize: 14, color: '#111827' }}>
                <strong>المدة:</strong>
                {' '}
                {session.duration_minutes}
                {' '}
                دقيقة
              </div>
            )}
            {session.attempts_allowed != null && (
              <div style={{ fontSize: 14, color: '#111827' }}>
                <strong>عدد المحاولات المسموحة:</strong>
                {' '}
                {session.attempts_allowed}
              </div>
            )}
          </div>

          <div style={{ marginTop: 4 }}>
            <button
              type="button"
              onClick={onStart}
              disabled={starting}
              style={{
                padding: '8px 14px',
                borderRadius: 999,
                border: '1px solid #1e3a8a',
                background: '#1e3a8a',
                color: '#ffffff',
                cursor: 'pointer',
                fontSize: 15,
                minWidth: 220,
              }}
            >
              {starting ? 'جاري البدء...' : 'بدء / استئناف الامتحان'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
